(function () {
  const toast = (() => {
    let node = document.querySelector('[data-hwdp-toast]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'hwdp-toast';
      node.setAttribute('data-hwdp-toast', '');
      document.body.appendChild(node);
    }
    let timer;
    return (message) => {
      node.textContent = message;
      node.classList.add('is-visible');
      window.clearTimeout(timer);
      timer = window.setTimeout(() => node.classList.remove('is-visible'), 1800);
    };
  })();

  const openCartDrawer = () => {
    const drawer = document.querySelector('[data-hwd-cart-drawer]');
    const overlay = document.querySelector('[data-hwd-cart-overlay]');
    if (!drawer || !overlay) return false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('hidden');
    document.body.classList.add('hwd-cart-open');
    return true;
  };

  const refreshCartDrawer = async () => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 4500);
    try {
      const response = await fetch(`/?sections=cart-drawer&hwdp_cart=${Date.now()}`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: controller.signal,
      });
      if (!response.ok) return openCartDrawer();
      const sections = await response.json();
      const html = sections['cart-drawer'];
      if (!html) return openCartDrawer();
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const next = wrapper.querySelector('#shopify-section-cart-drawer');
      const current = document.querySelector('#shopify-section-cart-drawer');
      if (next && current) current.replaceWith(next);
      openCartDrawer();
    } catch (error) {
      openCartDrawer();
    } finally {
      window.clearTimeout(timeout);
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-hwdp-product-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const productUrl = form.getAttribute('data-product-url') || '/pages/shop';
    const formData = new FormData(form);
    const id = Number(formData.get('id'));

    if (!id) {
      window.location.href = productUrl;
      return;
    }

    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id,
          quantity: Number(formData.get('quantity') || 1),
        }),
      });

      if (!response.ok) throw new Error('Cart add failed');
      await response.json();
      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
      window.location.href = productUrl;
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original || 'Add to cart';
      }
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.hwdp-select');
    if (!select) return;
    const option = select.selectedOptions?.[0];
    const imageSrc = option?.getAttribute('data-image-src');
    if (!imageSrc) return;
    const card = select.closest('.hwdp-product-card');
    const image = card?.querySelector('.hwdp-product-card__image img');
    if (!image) return;
    image.src = imageSrc;
    image.srcset = '';
  });

  const setupRailDots = (railSelector, dotsSelector) => {
    const rail = document.querySelector(railSelector);
    const dots = document.querySelector(dotsSelector);
    if (!rail || !dots) return;

    const pageCount = () => Math.max(1, Math.ceil((rail.scrollWidth - 1) / Math.max(1, rail.clientWidth)));

    const render = () => {
      const pages = pageCount();
      if (dots.children.length !== pages) {
        dots.innerHTML = '';
        for (let index = 0; index < pages; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => {
            rail.scrollTo({ left: index * rail.clientWidth, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        }
      }
      const active = Math.round(rail.scrollLeft / Math.max(1, rail.clientWidth));
      Array.from(dots.children).forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };

    rail.addEventListener('scroll', render, { passive: true });
    window.addEventListener('resize', render);
    render();

    const startKey = rail.getAttribute('data-hwdp-start-card');
    const startCard = startKey ? rail.querySelector(`[data-hwdp-card-key="${startKey}"]`) : null;
    if (startCard && window.matchMedia('(max-width: 759px)').matches) {
      requestAnimationFrame(() => {
        rail.scrollLeft = Math.max(0, startCard.offsetLeft - rail.offsetLeft);
        render();
      });
    }
  };

  const setupCardDots = (railSelector, dotsSelector) => {
    const rail = document.querySelector(railSelector);
    const dots = document.querySelector('[data-hwdp-dots="bundles"]');
    if (!rail || !dots) return;

    const originalCards = Array.from(rail.querySelectorAll('[data-hwdp-card-key]'));
    const mobileLoop = window.matchMedia('(max-width: 759px)').matches;
    if (mobileLoop && originalCards.length > 1 && !rail.hasAttribute('data-hwdp-loop-ready')) {
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      originalCards.forEach((card) => {
        const preClone = card.cloneNode(true);
        const postClone = card.cloneNode(true);
        preClone.setAttribute('data-hwdp-card-clone', 'before');
        postClone.setAttribute('data-hwdp-card-clone', 'after');
        before.appendChild(preClone);
        after.appendChild(postClone);
      });
      rail.insertBefore(before, originalCards[0]);
      rail.appendChild(after);
      rail.setAttribute('data-hwdp-loop-ready', 'true');
    }

    const scrollToCard = (card, behavior = 'auto') => {
      if (!card) return;
      rail.scrollTo({ left: Math.max(0, card.offsetLeft - rail.offsetLeft), behavior });
    };

    const cards = () => Array.from(rail.querySelectorAll('[data-hwdp-card-key]'));
    const middleCards = () => Array.from(rail.querySelectorAll('[data-hwdp-card-key]:not([data-hwdp-card-clone])'));

    const loopMetrics = () => {
      const middle = middleCards();
      if (!middle.length) return null;
      const first = middle[0];
      const last = middle[middle.length - 1];
      const start = Math.max(0, first.offsetLeft - rail.offsetLeft);
      const end = Math.max(start + 1, last.offsetLeft - rail.offsetLeft + last.offsetWidth);
      return { start, end, width: end - start };
    };

    let isResetting = false;
    let resetFrame = 0;
    const rebalanceLoop = () => {
      if (isResetting) return;
      const metrics = loopMetrics();
      if (!metrics || metrics.width < 1) return;
      const left = rail.scrollLeft;
      const beforeLimit = metrics.start - metrics.width * 0.92;
      const afterLimit = metrics.end - rail.clientWidth + metrics.width * 0.92;
      if (left < beforeLimit) {
        isResetting = true;
        cancelAnimationFrame(resetFrame);
        resetFrame = requestAnimationFrame(() => {
          rail.scrollLeft = left + metrics.width;
          requestAnimationFrame(() => { isResetting = false; render(); });
        });
      } else if (left > afterLimit) {
        isResetting = true;
        cancelAnimationFrame(resetFrame);
        resetFrame = requestAnimationFrame(() => {
          rail.scrollLeft = left - metrics.width;
          requestAnimationFrame(() => { isResetting = false; render(); });
        });
      }
    };

    const closestCard = () => {
      return cards().reduce((best, card) => {
        const distance = Math.abs((card.offsetLeft - rail.offsetLeft) - rail.scrollLeft);
        return !best || distance < best.distance ? { card, distance } : best;
      }, null)?.card;
    };

    const render = () => {
      const activeKey = closestCard()?.getAttribute('data-hwdp-card-key');
      Array.from(dots.children).forEach((dot) => {
        dot.classList.toggle('is-active', dot.getAttribute('data-key') === activeKey);
      });
    };

    dots.innerHTML = '';
    middleCards().forEach((card) => {
      const key = card.getAttribute('data-hwdp-card-key');
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('data-key', key);
      dot.setAttribute('aria-label', `Go to ${key} bundle`);
      dot.addEventListener('click', () => {
        const target = middleCards().find((middleCard) => middleCard.getAttribute('data-hwdp-card-key') === key);
        scrollToCard(target || card, 'smooth');
      });
      dots.appendChild(dot);
    });

    let scrollFrame = 0;
    rail.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        rebalanceLoop();
        render();
      });
    }, { passive: true });
    window.addEventListener('resize', () => {
      const activeKey = closestCard()?.getAttribute('data-hwdp-card-key') || 'full';
      const target = middleCards().find((card) => card.getAttribute('data-hwdp-card-key') === activeKey);
      requestAnimationFrame(() => {
        scrollToCard(target || middleCards()[0]);
        render();
      });
    });

    window.requestAnimationFrame(() => {
      const full = middleCards().find((card) => card.getAttribute('data-hwdp-card-key') === 'full');
      scrollToCard(full || middleCards()[0]);
      render();
    });
  };

  const initCountdown = () => {
    const root = document.querySelector('[data-hwdp-countdown]');
    if (!root) return;
    const hours = root.querySelector('[data-hwdp-countdown-hours]');
    const minutes = root.querySelector('[data-hwdp-countdown-minutes]');
    const seconds = root.querySelector('[data-hwdp-countdown-seconds]');
    const pad = (value) => String(value).padStart(2, '0');
    const update = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const diff = Math.max(0, midnight.getTime() - now.getTime());
      const totalSeconds = Math.floor(diff / 1000);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
    };
    update();
    window.setInterval(update, 1000);
  };

  const initDots = () => {
    setupRailDots('.hwdp-shop-rail', '[data-hwdp-dots="products"]');
    setupCardDots('[data-hwdp-bundle-rail]', '[data-hwdp-dots="bundles"]');
    initCountdown();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDots);
  } else {
    initDots();
  }
})();
